import { render } from "./VSelectAlternativeOpenIndicator.vue?vue&type=template&id=62335dbe"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/VSelectAlternativeOpenIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62335dbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62335dbe', __exports__)) {
    api.reload('62335dbe', __exports__)
  }
  
  module.hot.accept("./VSelectAlternativeOpenIndicator.vue?vue&type=template&id=62335dbe", () => {
    api.rerender('62335dbe', render)
  })

}


export default __exports__